<template>
  <v-container
    fluid
    grid-list-md
    class="pa-2"
  >
    <v-layout
      v-if="loading"
      row
      wrap
      justify-center
    >
      <v-progress-circular
        :size="64"
        :width="3"
        indeterminate
        color="primary"
      />
    </v-layout>
    <v-layout
      v-else
      row
      wrap
      justify-center
    >
      <v-flex class="profile">
        <v-card class="pa-2 text-xs-center max-shadow">
          <v-btn
            flat
            icon
            absolute
            left
            color="accent"
            @click="$refs.profilePhoto.changePhoto()"
          >
            <v-tooltip bottom>
              <v-icon slot="activator">
                photo_camera
              </v-icon>
              <span>Change Photo</span>
            </v-tooltip>
          </v-btn>
          <!-- <v-btn 
            flat
            icon
            absolute
            right
            color="primary"
            @click="editEmployeeDialog = true">
            <v-tooltip bottom>
              <v-icon slot="activator">edit</v-icon>
              <span>Edit Profile</span>
            </v-tooltip>
          </v-btn>-->
          <div class="text-xs-center">
            <profile-photo
              ref="profilePhoto"
              :src="profile.photo"
              :size="120"
            />
            <div class="title grey--text text--darken-2 py-3">
              {{ profile.name }}
            </div>
          </div>
          <v-divider />
          <v-list
            dense
            class="pa-3"
          >
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>phone</v-icon>
              </v-list-tile-action>
              <v-list-tile-content class="subheading">
                {{ profile.phone }}
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon>email</v-icon>
              </v-list-tile-action>
              <v-list-tile-content class="subheading">
                {{ profile.email }}
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <div class="d-flex">
            <v-btn
              flat
              color="primary"
              @click="changePasswordDialog = true"
            >
              Change Password
            </v-btn>
          </div>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="pa-2 max-shadow">
          details
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="changePasswordDialog"
      lazy
      persistent
      max-width="450px"
    >
      <v-card class="max-shadow">
        <v-card-title primary-title>
          <div class="headline">
            Change Password
          </div>
        </v-card-title>
        <v-card-text>
          <v-form ref="changePasswordForm">
            <v-text-field
              ref="oldPasswordField"
              v-model="changePasswordData.oldPassword"
              :rules="[
                v => !!v || 'required',
                v => (!!v && v.length > 5) || 'Password must have min 6 characters'
              ]"
              :append-icon="changePasswordData.passwordVisible ? 'visibility_off' : 'visibility'"
              :append-icon-cb="
                () => (changePasswordData.passwordVisible = !changePasswordData.passwordVisible)
              "
              :type="changePasswordData.passwordVisible ? 'text' : 'password'"
              label="Old Password"
              required
            />
            <v-text-field
              ref="passwordField"
              v-model="changePasswordData.newPassword"
              :rules="[
                v => !!v || 'required',
                v => (!!v && v.length > 5) || 'Password must have min 6 characters'
              ]"
              :append-icon="changePasswordData.passwordVisible ? 'visibility_off' : 'visibility'"
              :append-icon-cb="
                () => (changePasswordData.passwordVisible = !changePasswordData.passwordVisible)
              "
              :type="changePasswordData.passwordVisible ? 'text' : 'password'"
              label="New Password"
              required
            />
            <v-text-field
              ref="confirmPassword"
              v-model="changePasswordData.confirmPassword"
              :rules="[
                v => !!v || 'required',
                v => (!!v && v === $refs.passwordField.inputValue) || 'Passwords don\'t match'
              ]"
              :append-icon="changePasswordData.passwordVisible ? 'visibility_off' : 'visibility'"
              :append-icon-cb="
                () => (changePasswordData.passwordVisible = !changePasswordData.passwordVisible)
              "
              :type="changePasswordData.passwordVisible ? 'text' : 'password'"
              label="Confirm New Password"
              required
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            flat
            color="primary"
            @click.stop="_cancelDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            :loading="changePasswordData.loading"
            flat
            color="primary"
            @click.stop="_changePassword"
          >
            Change
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="0"
      bottom
    >
      {{ snackbarMessage }}
      <v-btn
        flat
        @click.native="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import firebase from 'firebase/app';
import { firestore, auth } from '@/firebase';

import ProfilePhoto from '@/components/common/ProfilePhoto';

export default {
  name: 'Profile',
  components: {
    'profile-photo': ProfilePhoto
  },
  data() {
    return {
      loading: true,
      profile: {},
      snackbar: false,
      snackbarMessage: '',
      snackbarColor: 'primary',
      changePasswordDialog: false,
      changePasswordData: {
        passwordVisible: false,
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
        loading: false
      }
    };
  },

  created() {
    this._fetchProfile();
  },

  methods: {
    _fetchProfile() {
      firestore
        .collection('users')
        .doc(this.$store.state.profile.uid)
        .get()
        .then(userSnapshot => {
          this.profile = userSnapshot.data().profile;
        })
        .catch(error => {
          this.snackbarMessage = `Error - ${error.message}`;
          this.snackbarColor = 'error';
          this.snackbar = true;
        })
        .then(() => {
          this.loading = false;
        });
    },

    _cancelDialog() {
      this.$refs.changePasswordForm.reset();
      this.changePasswordDialog = false;
    },

    _changePassword() {
      const form = this.$refs.changePasswordForm;
      if (!form.validate()) return;

      this.changePasswordData.loading = true;
      const authCredential = firebase.auth.EmailAuthProvider.credential(
        this.profile.email,
        this.changePasswordData.oldPassword
      );

      auth.currentUser
        .reauthenticateWithCredential(authCredential)
        .then(() =>
          auth.currentUser
            .updatePassword(this.changePasswordData.newPassword)
            .then(() => {
              this.snackbarColor = 'success';
              this.snackbarMessage = 'Password has been updated';
              this.snackbar = true;
              this.changePasswordDialog = false;
            })
        )
        .catch(error => {
          this.snackbarColor = 'error';
          if (error.code === 'auth/wrong-password') {
            this.snackbarMessage = 'Old password is wrong!';
          } else {
            this.snackbarMessage = error.message;
          }
          this.snackbar = true;
        })
        .then(() => {
          this.changePasswordData.loading = false;
        });
    }
  }
};
</script>
<style scoped>
.profile {
  max-width: 300px;
  min-width: 300px;
}
</style>
